
export default function ManufacturerSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">取扱いメーカー</h2>
          <p className="text-lg text-gray-600">
            それぞれの特徴を活かした最適なソリューションをご提案
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* FJDynamics */}
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-[#2A6041] rounded-lg flex items-center justify-center mr-4">
                <i className="ri-settings-3-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">FJDynamics</h3>
                <p className="text-gray-600">高機能・高互換性システム</p>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">優れた機器互換性</h4>
                  <p className="text-gray-600 text-sm">AT2シリーズをベースに、レベラーや精密スプレーなどのオプションを追加可能。ISOBUS対応でトラクターと作業機間のデータ連携を実現</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">大画面ディスプレイ</h4>
                  <p className="text-gray-600 text-sm">ISOBUS機器の管理画面が見やすく、複雑な作業も効率的に</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">幅広い速度対応</h4>
                  <p className="text-gray-600 text-sm">基本速度0.5km/h〜12km/h、オプションのホールセンサー使用で0.1km/hの超低速作業にも対応</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">1台のモニターで複数台運用</h4>
                  <p className="text-gray-600 text-sm">拡張キットを導入すれば、1台のモニターを使い回すことで、トラクターと田植機など同時に使用しない機器に載せ替えが簡単。低価格で複数台自動操舵可能</p>
                </div>
              </div>
              
              <div className="bg-yellow-50 p-4 rounded-lg mt-4">
                <p className="text-sm text-gray-700">
                  <i className="ri-information-line text-yellow-600 mr-2"></i>
                  世界累計10万台以上、国内5,000台を超える導入実績。スマートフォンなどのデジタル機器に慣れた方におすすめ
                </p>
              </div>
            </div>
          </div>

          {/* EFIX */}
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-[#2A6041] rounded-lg flex items-center justify-center mr-4">
                <i className="ri-user-smile-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">EFIX</h3>
                <p className="text-gray-600">簡単操作・初心者向けシステム</p>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">クラシック・プロフェッショナルモード切替</h4>
                  <p className="text-gray-600 text-sm">AgNav 5.0ソフトウェアで、ユーザーの使用習慣に合わせてモード切替が可能</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">超低速から高速まで対応</h4>
                  <p className="text-gray-600 text-sm">標準で0.1km/hから30km/hまで幅広い作業速度をサポート。播種、散布、整地などの全作業に対応</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">ISOBUS対応</h4>
                  <p className="text-gray-600 text-sm">VT/TC-SC/TC-GEOに対応し、高度な農機具制御が可能</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-[#76B947] text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">独自のSkyTrixサービス</h4>
                  <p className="text-gray-600 text-sm">基地局やネットワーク信号が不要で、±2.5cmの高精度を短い収束時間（5分未満）で提供</p>
                </div>
              </div>
              
              <div className="bg-blue-50 p-4 rounded-lg mt-4">
                <p className="text-sm text-gray-700">
                  <i className="ri-information-line text-blue-600 mr-2"></i>
                  シンプルな操作を重視する方、初めて自動操舵を導入する方におすすめ
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}